import React from 'react';
import FinancialGroupedBarChart from '@components/charts/FinancialGroupedBarChart';
import TrendsSection from './TrendsSection';
import ChartLegend from './ChartLegend';
import FinancialMatrixTable from './FinancialMatrixTable';
import type { FinancialSection } from '@app-types/performanceTrends';

export interface CashFlowSectionProps {
  data: FinancialSection;
}

/** Cash flow section: 3-series grouped bars around a zero line (Figma 3490:22285). */
const CashFlowSection: React.FC<CashFlowSectionProps> = ({ data }) => (
  <TrendsSection
    title={data.title}
    headerNodeId={data.headerNodeId}
    sectionNodeId={data.sectionNodeId}
    anchorId="cashflow"
  >
    <div className="trends-financial-chart">
      <FinancialGroupedBarChart
        data={data.chart}
        height={202}
        ariaLabel={`${data.title}のチャート`}
      />
      <ChartLegend series={data.legend} nodeId="3157:8731" />
    </div>
    <FinancialMatrixTable data={data.table} caption={data.title} />
  </TrendsSection>
);

export default CashFlowSection;
